import React, { createContext, useContext, useState } from 'react';
import DSAlert, { Alert } from '../design-system/DSAlert';
import DSSnackbar from '../design-system/DSSnackbar';

type AlertContextType = {
  alert: Alert | undefined;
  showAlert: (alert: Alert | undefined) => void;
};

export const AlertContext = createContext<AlertContextType | undefined>(
  undefined,
);

export const useAlertContext = () => {
  const context = useContext(AlertContext);
  if (context === undefined) {
    throw new Error(
      'useAlertContext must be used within an AlertContextProvider',
    );
  }
  return context;
};

type Props = {
  children: React.ReactNode;
};

const AlertContextProvider: React.FC<Props> = ({ children }) => {
  const [alert, setAlert] = useState<Alert | undefined>(undefined);

  return (
    <AlertContext.Provider value={{ alert, showAlert: setAlert }}>
      {children}
      {alert && (
        <DSSnackbar
          open={!!alert}
          autoHideDuration={5000}
          onClose={() => setAlert(undefined)}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <DSAlert message={alert.message} alertType={alert.alertType} />
        </DSSnackbar>
      )}
    </AlertContext.Provider>
  );
};

export default AlertContextProvider;
